(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hotspot-showcase-complete-2bb0bad1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__hscShowcaseBound) return;
    window.__hscShowcaseBound = true;

    const getChoice = (root, key) => {
      return Array.from(root.querySelectorAll('[data-hsc-choice]')).find(
        (input) => input.dataset.hscChoice === key
      );
    };

    const syncLinks = (root) => {
      root.querySelectorAll('[data-hsc-card]').forEach((card) => {
        const choice = getChoice(root, card.dataset.hscCard);
        const link = card.querySelector('a[data-hsc-url]');
        if (!choice || !link) return;
        if (choice.checked) {
          link.setAttribute('href', link.dataset.hscUrl);
          link.removeAttribute('role');
          link.removeAttribute('tabindex');
        } else {
          link.removeAttribute('href');
          link.setAttribute('role', 'button');
          link.setAttribute('tabindex', '0');
        }
      });
    };

    const selectCard = (root, choice) => {
      choice.checked = true;
      choice.dispatchEvent(new Event('change', { bubbles: true }));
      syncLinks(root);
    };

    const handleClick = (event) => {
      if (!(event.target instanceof Element)) return;
      const card = event.target.closest('[data-hsc-card]');
      if (!card) return;
      const root = card.closest('[data-hotspot-showcase]');
      if (!root) return;
      const choice = getChoice(root, card.dataset.hscCard);
      if (!choice) return;
      if (choice.checked) {
        syncLinks(root);
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      selectCard(root, choice);
    };

    document.addEventListener('click', handleClick, true);
    document.addEventListener('auxclick', handleClick, true);
    document.addEventListener('change', (event) => {
      if (!(event.target instanceof Element)) return;
      if (!event.target.matches('[data-hsc-choice]')) return;
      const root = event.target.closest('[data-hotspot-showcase]');
      if (root) syncLinks(root);
    });
    document.addEventListener('keydown', (event) => {
      if (!(event.target instanceof Element)) return;
      const control = event.target.closest('.hsc__card-action');
      if (!control) return;
      const card = control.closest('[data-hsc-card]');
      const root = control.closest('[data-hotspot-showcase]');
      if (!card || !root) return;
      const choice = getChoice(root, card.dataset.hscCard);
      if (!choice) return;
      const activate = event.key === 'Enter' || event.key === ' ';
      if (!activate) return;
      if (!choice.checked) {
        event.preventDefault();
        event.stopImmediatePropagation();
        selectCard(root, choice);
      }
    }, true);

    const initialize = (container) => {
      container.querySelectorAll('[data-hotspot-showcase]').forEach(syncLinks);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const card = event.target.closest('[data-hsc-card]');
      if (!card) return;
      const root = card.closest('[data-hotspot-showcase]');
      if (!root) return;
      const choice = getChoice(root, card.dataset.hscCard);
      if (choice) selectCard(root, choice);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
